import { useEffect, useRef } from "react";
import { testimonials } from "@/mocks/bbCoffeeData";

export default function Testimonials() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("revealed");
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -50px 0px" }
    );
    const els = sectionRef.current?.querySelectorAll(".reveal-on-scroll");
    els?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section id="testimonials" ref={sectionRef} className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-14 reveal-on-scroll">
          <span className="inline-block px-4 py-1.5 mb-4 text-xs font-semibold tracking-widest uppercase text-accent-600 bg-accent-100 rounded-full">
            Testimonials
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 mb-4">
            Loved by the <span className="text-primary-600">Community</span>
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            Real reviews from real coffee lovers. Here&apos;s what our customers say about us.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {testimonials.map((t) => (
            <div
              key={t.handle}
              className="reveal-on-scroll bg-background-50 rounded-2xl p-6 transition-all duration-500 hover:-translate-y-1 cursor-default"
            >
              <div className="flex items-center gap-1 mb-3">
                {[1, 2, 3, 4, 5].map((s) => (
                  <div key={s} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-sm text-primary-500" />
                  </div>
                ))}
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed mb-5 italic">&ldquo;{t.text}&rdquo;</p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    alt={t.name}
                    className="w-full h-full object-cover"
                    src={t.avatar}
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-400">{t.handle}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}